import ServicePageTemplate from '../services/ServicePageTemplate';
import { servicePageData } from '../../mocks/servicePages';
const AirQualityPage = () => <ServicePageTemplate data={servicePageData['air-quality']} />;
export default AirQualityPage;
